module.exports = __webpack_public_path__ + "img/aguaacolman.58c3da9f.jpg";